import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";

import { FaBell } from "react-icons/fa6";

import {
  Loader,
  Spacer,
  application,
  boxContainer,
  tables,
} from "../../components";

import { ApplicationAction } from "../../store/actions";

function ApplicationDetails() {
  const dispatch = useDispatch();
  const location = useLocation();

  const uniId = location.pathname.split("/")[2];

  const [searchParams, setSearchParams] = useSearchParams();

  const { applicationData, isApplicationLoading } = useSelector(
    (state) => state.application
  );
  const profileData = useSelector((state) => state.profile?.user);
  const schoolId =
    profileData?.role === "school"
      ? profileData?.schoolId
      : profileData?.staff?.schoolId;

  useEffect(() => {
    dispatch(
      ApplicationAction.getApplications({ limit: 10, offset: 0, schoolId })
    );
    dispatch(ApplicationAction.getApplicationDetails({ uniId: uniId }));
  }, [location?.pathname, profileData]);

  const handleNotify = () => {};

  const columns = [
    {
      title: " ",
      dataIndex: "index",
      key: "0",
      width: 5,
      render: (text, record, index) => (
        <div className="flex gap-2 items-center">{index + 1}</div>
      ),
    },
    {
      title: "Student Name",
      dataIndex: "name",
      key: "1",
      width: 200,
      render: (text, record) => (
        <div className="flex gap-2 items-center">
          <img
            src={record?.student?.userId?.profileImage}
            className="h-[3.75em] w-[3.75em] border border-searchBorder shadow-boxContainer rounded-lg object-contain bg-white"
          />

          <div className="font-semibold">
            {record?.student?.userId?.firstName}{" "}
            {record?.student?.userId?.lastName}
          </div>
        </div>
      ),
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "10",
      width: 180,
      align: "center",
      render: (text, record) => (
        <div className="flex flex-col">{record?.student?.grade ?? "NA"}</div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "2",
      width: 120,
      align: "center",
      render: (text, record) => (
        <div>{record?.student?.userId?.email ?? "NA"}</div>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "4",
      width: 120,
      align: "center",
      render: (text, record) => (
        <div>
          {record?.student?.userId?.phoneNumber
            ? `+${record?.student?.userId?.phoneNumber}`
            : "NA"}
        </div>
      ),
    },
    {
      title: "Preferred Subject",
      dataIndex: "subject",
      key: "5",
      width: 120,
      align: "center",
      render: (text, record) => (
        <div>{record?.prefrerredMajor?.programType ?? "NA"}</div>
      ),
    },
    {
      title: "Appplication Decision",
      dataIndex: "decision",
      key: "6",
      width: 150,
      align: "center",
      render: (text, record) => (
        <div
          className={`${
            record?.status?.toLowerCase() === "accepted"
              ? "text-activeText"
              : record?.status?.toLowerCase() === "pending"
              ? "text-pendingText"
              : record?.status?.toLowerCase() === "rejected"
              ? "text-red-600"
              : "text-onlineText"
          }`}
        >
          {record?.status ?? "NA"}
        </div>
      ),
    },
  ];

  return (
    <div className="text-black">
      {isApplicationLoading ? (
        <Loader.Circular />
      ) : (
        <div>
          <div className="px-[50px]">
            <application.ApplicationTopAnalytics />
          </div>
          <Spacer height={30} />
          <boxContainer.LiteBoxContainer addstyle={"!p-0 rounded-b-sm"}>
            <div>
              <div className="py-3 px-4 flex justify-between items-center">
                <div className="font-bold pl-4">
                  Student who applied in {searchParams.get("university")}
                </div>
                <div
                  className="bg-main rounded-lg text-white font-semibold flex gap-2 py-2 px-3 text-[0.875em] items-center cursor-pointer"
                  onClick={handleNotify}
                >
                  <FaBell className="text-pendingText" /> Remind Students to
                  update application decision
                </div>
              </div>
              <tables.DefaultTable
                columns={columns}
                data={applicationData}
                borderradius={0}
                rowKey={() => Math.random()}
                loading={isApplicationLoading}
              />
            </div>
          </boxContainer.LiteBoxContainer>
        </div>
      )}
    </div>
  );
}

export default ApplicationDetails;
